export default {
  header: 'Potvrdiť',
  processFlow: 'Tok procesu',
  box: 'Box',
  prio: 'Priorita',
  testLoad: 'Testovacia záťaž',
};
